import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { dashboardActions } from '@src/store/reducers/dashboardReducer';

export const createDashboardMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [dashboardActions.GET_DASHBOARD_DEPLOY_STATUS]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Projects/Statistics/GetSuccessVsFailedDeployments`, payload);
            next({ type: dashboardActions.SET_DASHBOARD_DEPLOY_STATUS, payload: { successVsFailedDeployments: response.data } });
            return response.data;
        },
        [dashboardActions.GET_DASHBOARD_AVERAGE_DEPLOY]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Projects/Statistics/GetAverageDeployments`, payload);
            next({ type: dashboardActions.SET_DASHBOARD_AVERAGE_DEPLOY, payload: { averageDeployments: response.data } });
            return response.data;
        },
        [dashboardActions.GET_DASHBOARD_MOST_ACTIVE_PROJECTS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/Statistics/MostActiveProjects/Period/${payload.period}`);
            next({ type: dashboardActions.SET_DASHBOARD_MOST_ACTIVE_PROJECTS, payload: { mostActiveProjects: response.data } });
            return response.data;
        },
        [dashboardActions.GET_DASHBOARD_MY_PROJECTS]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/WithDeployStatusModified`);
            next({ type: dashboardActions.SET_DASHBOARD_MY_PROJECTS, payload: { myProjects: response.data } });
            return response.data;
        },
        [dashboardActions.GET_DASHBOARD_PROJECTS]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects`);
            next({ type: dashboardActions.SET_DASHBOARD_PROJECTS, payload: { filterProjects: response.data } });
            return response.data;
        },
        [dashboardActions.GET_TIME_PERIODS]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/TimePeriods`);
            next({ type: dashboardActions.SET_TIME_PERIODS, payload: { filterPeriods: response.data } });
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/dashboard.middleware.ts